var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38326 1.05033C0.64959 3.784 0.64959 8.21616 3.38326 10.9498C3.57852 11.1451 3.57852 11.4617 3.38326 11.6569C3.188 11.8522 2.87142 11.8522 2.67615 11.6569C-0.448041 8.53274 -0.448041 3.46742 2.67615 0.343224C2.87142 0.147962 3.188 0.147962 3.38326 0.343224C3.57852 0.538486 3.57852 0.855068 3.38326 1.05033ZM5.50458 3.17165C3.94248 4.73375 3.94248 7.26641 5.50458 8.82851C5.69984 9.02377 5.69984 9.34035 5.50458 9.53561C5.30932 9.73087 4.99274 9.73087 4.79747 9.53561C2.84485 7.58299 2.84485 4.41717 4.79747 2.46454C4.99274 2.26928 5.30932 2.26928 5.50458 2.46454C5.69984 2.65981 5.69984 2.97639 5.50458 3.17165ZM11.1614 2.46454C11.3567 2.26928 11.6733 2.26928 11.8685 2.46454C13.8212 4.41717 13.8212 7.58299 11.8685 9.53561C11.6733 9.73087 11.3567 9.73087 11.1614 9.53561C10.9662 9.34035 10.9662 9.02377 11.1614 8.82851C12.7235 7.26641 12.7235 4.73375 11.1614 3.17165C10.9662 2.97639 10.9662 2.65981 11.1614 2.46454ZM13.2828 0.343224C13.478 0.147962 13.7946 0.147962 13.9899 0.343224C17.1141 3.46742 17.1141 8.53274 13.9899 11.6569C13.7946 11.8522 13.478 11.8522 13.2828 11.6569C13.0875 11.4617 13.0875 11.1451 13.2828 10.9498C16.0164 8.21616 16.0164 3.784 13.2828 1.05033C13.0875 0.855068 13.0875 0.538486 13.2828 0.343224Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 6.00008C10.333 7.10465 9.4376 8.00008 8.33303 8.00008C7.22847 8.00008 6.33303 7.10465 6.33303 6.00008C6.33303 4.89551 7.22847 4.00008 8.33303 4.00008C9.4376 4.00008 10.333 4.89551 10.333 6.00008Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.4b2b983f95e223963731f54145cc22e9.svg";
export { ForwardRef as ReactComponent };